var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    { class: { "md-input-invalid": _vm.showRequiredError } },
    [
      _c("label", [_vm._v(_vm._s(_vm.multiple ? "Networks" : "Network"))]),
      _c(
        "md-select",
        {
          attrs: {
            name: "network",
            multiple: _vm.multiple,
            disabled: _vm.networks.length === 0
          },
          on: { selected: _vm.onNetworkSelected },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        _vm._l(_vm.networks, function(network) {
          return _c(
            "md-option",
            { key: network._id, attrs: { value: network._id } },
            [_vm._v(_vm._s(network.name))]
          )
        }),
        1
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRequiredError,
              expression: "showRequiredError"
            }
          ],
          staticClass: "md-error"
        },
        [_vm._v("This field is required")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3304eb92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3304eb92","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/network/NetworkSelector.vue
// module id = 719
// module chunks = 0